appSocial.service('SocialLocaleService', [
    '$rootScope', 'SocialConfig', 'en_Locale',
    function ($rootScope, config, en_Locale) {

        const Langs = {
            en: en_Locale
        }

        class SocialLocaleService {
            constructor() {
                this.translation = {};
            }

            init() {
                return this.loadLang(config.defaultLang);
            }

            loadLang(lang) {
                return this.loadPrimaryLang(lang)
                    .then(([lang, translation]) => {
                        this.lang = lang;
                        this.translation = translation;
                        $rootScope.$emit('SocialLocaleService.change', this.translation)
                    })
            }

            /**
             * Load language from remote source/local cache
             * @param lang
             * @returns {*}
             */
            loadPrimaryLang(lang) {
                return Promise.resolve()
                    .then(() => {
                        if (!Langs[lang]) {
                            return Promise.reject('no such locale');
                        }
                        this.translation = _.defaultsDeep({}, Langs[lang], Langs.en); //merge with english, defaultsDeep works from right to left
                        return [lang, this.translation];
                    })
                    .catch((error) => {
                        this.translation = Langs.en;
                        return [lang, this.translation];
                    });
            }

            /**
             * Translates labels for array of objects
             * @param items
             * @param labelField
             * @return {*}
             */
            translateLabels(items, labelField = 'label') {
                return items.map(item => {
                    if (item.hasOwnProperty(labelField)) {
                        item.label = this.translation[item[labelField]] || item.label;
                    }
                    return item
                })
            }
        }

        return new SocialLocaleService();
    }]);
